import { Component, OnInit, EventEmitter, Output, Input, ViewChild, OnDestroy } from '@angular/core';
import { Initials, MyMerchant } from '../../models/initials.model';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { Router } from '@angular/router';
import { List } from 'src/app/state/product.model';
// import { ListQuery } from 'src/app/state/product.query';
// import { ListService } from 'src/app/state/product.service';
import { ResolverService } from '../..';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from 'src/app/modules/notification/services/notification.service';
import { MerchantDetail } from 'src/app/modules/dashboard/models/pin-list.model';
import { CustomersFacadeService } from 'src/app/modules/customers/services/customers-facade.service';
import { SnackBarService } from 'src/app/shared';
import { PermissionService } from '../../services/permission/permission.service';
import { PaymentService } from '../../../modules/online-payments/services/payment.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})

export class ToolbarComponent implements OnInit, OnDestroy {
  public expandSidbar = true;
  public initials = <Initials>{};
  public miniBasketListCount: number;
  public currentUrl: string;
  public userInit: any;
  // lists$: Observable<List[]>;
  userAvatar: string;
  hasPaymentAccess: boolean = false;
  isAdmin: boolean = false;
  isSubUser: boolean = false;
  outgoingMessageList: any
  displayedColumns = ['number', 'title', 'subject']
  displayName: string = '';
  environmentConfig = environment;
  paymentCategoryList: any;

  @Input() hideToggleButton: boolean = true;
  @Output() toggleSidbar = new EventEmitter<boolean>();
  @ViewChild('salesManagersDialog') salesManagersDialog;
  @ViewChild('outgoingMessageDetail') outgoingMessageDetail;
  @ViewChild('myMerchantListDialog') myMerchantListDialog;

  messageDetail: any;

  availableMerchants: MyMerchant[] = [];
  canViewWalletTransactions = this.permissionService.isAccountant || this.permissionService.isAdmin || this.permissionService.isOwner;
  constructor(
    // private listService: ListService,
    private storageService: LocalStorageService,
    // private query: ListQuery,
    private resolvedService: ResolverService,
    private router: Router,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private customersService: CustomersFacadeService,
    private snackbarService: SnackBarService,
    private permissionService: PermissionService,
    private paymentService: PaymentService,
  ) { }

  ngOnInit() {
    // this.lists$ = this.query.selectAll();
    this.initials = this.resolvedService.userInitInfo;
    this.initiateShell();
    // this.getLists();
    this.checkRoute();
    this.isOnlinePaymentPermitted();
    this.getOutgoingMessageList();
    this.getMerchantList();
    if(this.permissionService.isOwner || this.permissionService.isAdmin || this.permissionService.isAccountant) {
          this.getPaymentCategoryList();
    }
  }

  getMerchantList() {
    this.customersService.getMyMerchants({
      limit: 100,
      offset: 0
    }).subscribe(
      data => {
        this.availableMerchants = data.results;
      }
    )
  }

  checkRoute() {
    this.router.events.subscribe(() => {
      this.currentUrl = this.router.url;
    })
  }

  onToggleSidebar() {
    this.expandSidbar = !this.expandSidbar;
    this.toggleSidbar.emit(this.expandSidbar);
  }

  ngOnDestroy(): void {
    this.toggleSidbar.emit();
    // this.toggleSidbar.complete();
  }

  initiateShell() {
    this.isSubUser = !this.permissionService.isAdmin && !this.permissionService.isOwner;
    this.displayName = this.initials.merchant_detail.user_detail.first_name + " " + this.initials.merchant_detail.user_detail.last_name;
    this.initials.active_gifts = this.resolvedService.userInitInfo.active_gifts;
    this.initials.balance = this.resolvedService.userInitInfo.balance;
    this.initials.deactivated_gifts = this.resolvedService.userInitInfo.deactivated_gifts;
    this.initials.profile = this.resolvedService.userInitInfo.profile;
    this.initials.total_sell = this.resolvedService.userInitInfo.total_sell;
    this.userAvatar = this.resolvedService.userInitInfo.profile.company_logo;
    this.resolvedService.updateInitInfo.subscribe(
      update => {
        if (update) {
          this.initials.profile = this.resolvedService.userInitInfo.profile;
        }
      }
    )
  }

  // getLists() {
  //   this.lists$.subscribe(data => {
  //     this.miniBasketListCount = data.length;
  //   })
  // }

  onLogout() {
    this.storageService.logoutUser();
    this.router.navigate(['/'])
  }

  // onRemovedItem(event) {
  //   this.listService.deleteList(event.id);
  // }

  isOnlinePaymentPermitted() {
    this.userInit = this.resolvedService.userInitInfo;
    if (this.userInit.profile.role.role_id === environment.role_types.admin) {
      this.isAdmin = true;
    }

    this.hasPaymentAccess = !this.isAdmin && !this.isSubUser;
  }

  hasDocumentAccess() {
    let canAccess = false;
    if (this.resolvedService.userInitInfo.profile.admin && !this.resolvedService.userInitInfo.profile.reseller) {
      canAccess = true;
    }
    return canAccess;
  }

  openSalesManagerDialog() {
    let dialog = this.dialog.open(this.salesManagersDialog, {
      width: '500px'
    });
  }

  getOutgoingMessageList() {
    let filters = { limit: 5, ordering: '-id' };
    this.notificationService.getOutgoingMessageList(filters).subscribe(res => {
      this.outgoingMessageList = res
    })
  }

  showMessageLog(message) {
    this.messageDetail = message;
    this.dialog.open(this.outgoingMessageDetail, {
      maxHeight: '600px',
      maxWidth: '80vw',
      autoFocus: false,
    })
  }

  showMerchantsDialog() {
    this.dialog.open(this.myMerchantListDialog, {
      data: this.availableMerchants,
      width: '300px'
    })
  }

  updateCurrentMerchant(company_id: number) {
    this.dialog.closeAll();
    this.customersService.selectCurrentCompany(company_id).subscribe(
      data => {
        this.resolvedService.updateInfo();
        this.storageService.accessToken = data.access
        window.location.reload();
      },
      error => {
        this.snackbarService.showSnack(error.detail);
      }
    )
  }

  getPaymentCategoryList() {
    this.paymentService.getPaymentCategoryList().subscribe(
      data => {
        this.paymentCategoryList = data;
      },
      error => {
        this.snackbarService.showSnack(error.detail);
      }
    )
  }
}
